import React from 'react';
import { OrderedListOutlined } from '@ant-design/icons';
import { Col, List, Row } from 'antd';

interface Props {
    no_quotable_items: {
        name: string;
        reason: string;
    }[];
}

export const NoQuotableLineItems = ({ no_quotable_items }: Props) => {
    if (!no_quotable_items?.length) {
        return null;
    }

    return (
        <React.Fragment>
            <List
                dataSource={no_quotable_items}
                itemLayout="horizontal"
                renderItem={item => (
                    <List.Item>
                        <List.Item.Meta title={item.name} description={item.reason} />
                    </List.Item>
                )}
            />
        </React.Fragment>
    );
};
